import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPSERT_VIEWPORTS: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation upsertViewports($input: UpsertViewportsInput!) {
    upsertViewports(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
